/**
 * Raw mutation service fns for the project-artifacts domain.
 *
 * Mirrors `features/manage-project-folders/api/project-folders.api.ts`:
 * mutations live in their feature slice; reads (list of attached artifacts)
 * live in `entities/project-artifact`.
 */
import {
  ProjectArtifactsService,
  type AttachArtifactsRequestDto,
  type AttachArtifactsResponseDto,
} from '@inference.engine/workspace-api-client/web';
import { workspaceHttp } from '@/lib/api/http-client';
import { SUPPRESS_ERROR_NOTIFICATION_HEADER } from '@/lib/api/interceptors/problem-details.interceptor';

export const attachArtifacts = async (
  projectId: string,
  body: AttachArtifactsRequestDto,
): Promise<AttachArtifactsResponseDto> => {
  const response = await ProjectArtifactsService.attach({
    client: workspaceHttp,
    path: { platformProjectId: projectId },
    body,
  });

  if (!response.data) {
    throw new Error('Failed to attach artifacts');
  }

  return response.data;
};

export const detachArtifact = async (
  projectId: string,
  projectArtifactId: string,
): Promise<void> => {
  await ProjectArtifactsService.detach({
    client: workspaceHttp,
    path: { platformProjectId: projectId, projectArtifactId },
    // eslint-disable-next-line i18next/no-literal-string -- request header value, never rendered
    headers: { [SUPPRESS_ERROR_NOTIFICATION_HEADER]: 'true' },
  });
};
